import { VIEW_DAY, VIEW_MONTH, VIEW_WEEK, VIEW_AGENDA, SERVICE_COLOR_PALETTE } from '@/lib/consts.js'

/** @constant {number} column width [px] */
export const CALENDAR_COLUMN_WIDTH = 250

/** @constant {number} mobile column min width [px] */
export const CALENDAR_COLUMN_WIDTH_MOBILE = 100

/** @constant {number} hour slot height [px] */
export const CALENDAR_HOUR_SLOT_HEIGHT = 80

/** @constant {number} minute slot height */
export const CALENDAR_MINUTE_SLOT_HEIGHT = CALENDAR_HOUR_SLOT_HEIGHT / 60

/** @constant {number} card height step */
export const HEIGHT_STEP = 15 * CALENDAR_MINUTE_SLOT_HEIGHT

/** @constant {number} vertical drag step [px] */
export const STEP = 5

/** @constant {number} card width */
export const CALENDAR_CARD_WIDTH = 249

/** @constant {number} drawer width */
export const CALENDAR_DRAWER_SHORT_WIDTH = 484

/** @constant {number} calendar weekday column width [px] */
export const CALENDAR_WEEKDAY_COLUMN_WIDTH = 180

/** @constant {number} sidebar default width */
export const SIDEBAR_TIMELINE_WIDTH = 74

/** @constant {number} sidebar width in week mode */
export const SIDEBAR_RESOURCE_WIDTH = 84

/** @constant {number} sidebar width in single resource week mode */
export const SIDEBAR_SINGLE_RESOURCE_WIDTH = SIDEBAR_TIMELINE_WIDTH + SIDEBAR_RESOURCE_WIDTH

/** @constant {number} sidebar default width */
export const SIDEBAR_FILTERS_WIDTH = 217

/** @constant {object} card types */
export const CARD_TYPES = {
  FUTURE: 'F',
  PAST: 'P',
  TODAY: 'T',
}

/** @constant {object} keys in calendar settings object */
export const CALENDAR_SETTINGS = {
  DEFAULT_VIEW: 'default-view',
  FIT_WIDTH: 'fit-width',
  SERVICE_COLOR_PALETTE: 'service-color-palette',
}

/** @constant {object} values for default view of calendar settings */
export const DEFAULT_VIEW_SETTINGS = {
  DAILY: VIEW_DAY,
  WEEKLY: VIEW_WEEK,
  MONTHLY: VIEW_MONTH,
  AGENDA: VIEW_AGENDA,
}

/** @constant {object} values for width mode of calendar settings */
export const WIDTH_MODE_SETTINGS = {
  FIT: 'fit',
  FIXED: 'fixed',
}

/** @constant {object} default model of calendar settings */
export const CALENDAR_SETTINGS_DEFAULT_MODEL = {
  [CALENDAR_SETTINGS.DEFAULT_VIEW]: DEFAULT_VIEW_SETTINGS.DAILY,
  [CALENDAR_SETTINGS.FIT_WIDTH]: WIDTH_MODE_SETTINGS.FIXED,
  [CALENDAR_SETTINGS.SERVICE_COLOR_PALETTE]: SERVICE_COLOR_PALETTE.VIVID,
}

export const CALENDAR_HOW_IT_WORKS = {
  DEFAULT_VIEW: 'default-view',
  DISPLAY_MODE: 'display-mode',
  WAITLIST: 'waitlist',
}

/** @constant {object} default calendar card icons keys */
export const CALENDAR_CARD_ICONS_KEYS = {
  WARNING: 'warning',
  BOOST: 'boost',
  PAID: 'paid',
  NO_SHOW: 'no-show',
  NEEDS_CONFIRMATION: 'needs-confirmation',
  IS_BOOKSY_GIFT_CARD: 'is-booksy-gift-card',
  HAS_NOTE: 'has-note',
  IS_HIGHLIGHTED: 'is-highlighted',
  IS_CHOOSEN: 'is-choosen',
  IS_CANCELED: 'is-canceled',
  STAFFER_REQUESTED_BY_CLIENT: 'staffer-requested-by-client',
  PREPAYMENT_AWAITING: 'prepayment-awaiting',
}

export const ADD_EVENT_DROPDOWN_OPENING_SOURCE = {
  FAB: 'fab',
  CALENDAR_CONTENT: 'calendar-content',
}

export const CALENDAR_PERFORMANCE_MARKERS = {
  REFRESH_START: 'calendar-refresh-start',
  REFRESH_END: 'calendar-refresh-enf',
}

export const CALENDAR_PERFORMANCE_MEASURES = {
  REFRESH_MEAUSURE: 'calendar-refresh-measure',
}
